var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasMultiple)?_c('div',{staticClass:"form-group"},[_c('Label',{attrs:{"text":_vm.label}}),_c('SelectInput',{attrs:{"options":_vm.options,"blank-option-name":'None',"disabled":!_vm.publicationId},model:{value:(_vm.subsiteId),callback:function ($$v) {_vm.subsiteId=$$v},expression:"subsiteId"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }